import { render, staticRenderFns } from "./sectionBanner.vue?vue&type=template&id=65b5b514&scoped=true&"
import script from "./sectionBanner.vue?vue&type=script&lang=js&"
export * from "./sectionBanner.vue?vue&type=script&lang=js&"
import style0 from "./sectionBanner.vue?vue&type=style&index=0&id=65b5b514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5b514",
  null
  
)

export default component.exports